import { combineReducers, configureStore } from "@reduxjs/toolkit";
import branchesSlice from "./slices/BranchesSlice";
import OffersSlice from "./slices/OffersSlice";
import CommonSlice from "./slices/CommonSlice";
import UserSlice from "./slices/UserSlice";
import SubscriptionSlice from "./slices/SubscriptionSlice";
import DashboardSlice from "./slices/DashboardSlice";
import LoyaltyProgramSlice from "./slices/LoyaltyProgramSlice";
import ChatSlice from "./slices/ChatSlice";
import OfferRedeemSlice from "./slices/OfferRedeemSlice";
import ReportSlice from "./slices/ReportsSlice";
import AnalyisSlice from "./slices/AnalysisSlice";

const rootReducer = combineReducers({
  commonStore: CommonSlice,
  userStore: UserSlice,
  branchesStore: branchesSlice,
  offersStore: OffersSlice,
  subscriptionStore: SubscriptionSlice,
  dashboardStore: DashboardSlice,
  loyaltyProgramStore: LoyaltyProgramSlice,
  chatStore: ChatSlice,
  offerRedeemStore: OfferRedeemSlice,
  reportStore: ReportSlice,
  analysisStore: AnalyisSlice,
});

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
